import React from 'react';
import { Globe2, Lock } from 'lucide-react';
import { clsx } from 'clsx';
import { isPhotoPublic } from '../../utils/moderationFormat';

const VisibilityBadge = ({ photo, compact = false }) => {
  const isPublic = isPhotoPublic(photo);
  const label = isPublic ? 'Pública' : 'Operacional';
  const Icon = isPublic ? Globe2 : Lock;
  const cls = isPublic
    ? 'bg-primary-100 text-primary-800 border-primary-300 dark:bg-primary-900/40 dark:text-primary-200 dark:border-primary-700'
    : 'bg-purple-100 text-purple-800 border-purple-300 dark:bg-purple-900/40 dark:text-purple-200 dark:border-purple-700';
  const title = isPublic
    ? 'Utilizador autorizou publicação no fogos.pt'
    : 'Apenas para uso ANEPC. Não vai aparecer publicamente, mesmo que aprovada.';
  return (
    <span
      title={title}
      className={clsx(
        'inline-flex items-center gap-1 border rounded-full font-medium',
        compact ? 'px-2 py-0.5 text-xs' : 'px-2.5 py-1 text-sm',
        cls,
      )}
    >
      <Icon className={compact ? 'w-3 h-3' : 'w-4 h-4'} />
      {label}
    </span>
  );
};

export default VisibilityBadge;
